// extracted by mini-css-extract-plugin
module.exports = {"retrycard":"TableCard_retrycard__1y6ew","tableBody":"TableCard_tableBody__2KZVn","tableHeading":"TableCard_tableHeading__3Ra8d"};